import React from "react";
import RenderError from "./RenderError";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.log("Error caught by boundary:", error, info);
  }

  render() {
    if (this.state.hasError) return <RenderError />;
    return this.props.children;
  }
}

export default ErrorBoundary;
